import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ChevronLeft,
  Gift,
  BadgePercent,
  Trophy,
  Crown,
  TicketPercent,
  MessageCircle,
} from "lucide-react";
import BottomNav from "../../components/BottomNav/BottomNav";
import "./RewardPage.css";
import InnerHeader from "../../components/InnerHeader";

export default function RewardPage() {
  const navigate = useNavigate();

  const rewardItems = [
    {
      title: "Promotions",
      colorClass: "rw-page-card--gold",
      Icon: BadgePercent,
      path: "/promotions",
    },
    {
      title: "Daily Turnover Bonus",
      colorClass: "rw-page-card--lavender",
      Icon: Gift,
      path: "/daily-turnover-bonus",
    },
    {
      title: "Big Turntable",
      colorClass: "rw-page-card--green",
      Icon: Trophy,
      path: "/big-turntable",
    },
    {
      title: "VIP",
      colorClass: "rw-page-card--cyan",
      Icon: Crown,
      path: "/vip",
    },
    {
      title: "Gift",
      colorClass: "rw-page-card--violet",
      Icon: Gift,
      path: "/gift",
    },
    {
      title: "Promo Code",
      colorClass: "rw-page-card--red",
      Icon: TicketPercent,
      path: "/promo-code",
    },
  ];

  const handleCardClick = (path) => {
    navigate(path);
  };

  return (
    <div className="rw-page">
     <InnerHeader title="Rewards"/>

      <main className="rw-page-body">
        <section className="rw-page-panel">
          <h2 className="rw-page-panel-title">Rewards</h2>

          <div className="rw-page-card-list">
            {rewardItems.map((item) => {
              const Icon = item.Icon;

              return (
                <button
                  key={item.title}
                  type="button"
                  className={`rw-page-card ${item.colorClass}`}
                  onClick={() => handleCardClick(item.path)}
                >
                  <span className="rw-page-card-label">{item.title}</span>

                  <span className="rw-page-card-art" aria-hidden="true">
                    <span className="rw-page-card-ring" />
                    <span className="rw-page-card-icon-wrap">
                      <Icon size={36} strokeWidth={2.2} />
                    </span>
                  </span>
                </button>
              );
            })}
          </div>
        </section>
      </main>

      <button type="button" className="rw-page-chat-btn" aria-label="Open chat">
        <MessageCircle size={30} fill="currentColor" strokeWidth={2.2} />
        <span className="rw-page-chat-badge">1</span>
      </button>

      <BottomNav />
    </div>
  );
}